import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useMemo } from 'react';
import { RichText } from '@sbercloud/uikit-product-site-rich-text';
import { Link } from '@snack-uikit/link';
import { Typography } from '@snack-uikit/typography';
import styles from "./styles.module.css";
import { getTitleTypographyProps } from './utils';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export function SectionTitle(_ref) {
  var title = _ref.title,
    titleLink = _ref.titleLink,
    description = _ref.description,
    _ref$titleSectionSize = _ref.titleSectionSize,
    titleSectionSize = _ref$titleSectionSize === void 0 ? 'm' : _ref$titleSectionSize,
    _ref$titleTag = _ref.titleTag,
    titleTag = _ref$titleTag === void 0 ? 'h2' : _ref$titleTag,
    layoutType = _ref.layoutType,
    _ref$titleAlign = _ref.titleAlign,
    titleAlign = _ref$titleAlign === void 0 ? 'left' : _ref$titleAlign;
  var titleProps = useMemo(function () {
    return getTitleTypographyProps({
      titleSectionSize: titleSectionSize,
      layoutType: layoutType
    });
  }, [layoutType, titleSectionSize]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: (title || description) && /*#__PURE__*/_jsxs("div", {
      className: styles.sectionTitle,
      "data-align": titleAlign,
      children: [title && /*#__PURE__*/_jsx(Typography, _objectSpread(_objectSpread({
        family: "sans"
      }, titleProps), {}, {
        tag: titleTag,
        className: styles.title,
        children: titleLink ? /*#__PURE__*/_jsx(Link, _objectSpread(_objectSpread(_objectSpread({}, titleLink), titleProps), {}, {
          text: title
        })) : /*#__PURE__*/_jsx(RichText, {
          richText: title
        })
      })), description && /*#__PURE__*/_jsx(Typography.SansBodyL, {
        className: styles.description,
        children: /*#__PURE__*/_jsx(RichText, {
          richText: description
        })
      })]
    })
  });
}